export const existingOnly = <T>(value?: T): value is T => value != null;

export const existsWithLength = (arr: unknown[]): boolean => !!arr?.length;

export const filterArchived = <T extends { archived?: boolean }>(items: T[]) =>
  items.filter(item => item.archived);
